
const data = [
    {
        id: 0,
        title: "Eget quis quam metus, scelerisque.",
        topText: "Odio felis sit leo, massa, mauris, at pulvinar ultrices. Euporttitor molestie massa porttitor. Quisque at turpis ut proin etiam rhoncus",
        bottomText: "Ac risus neque pulvinar tincidunt est. Tristique imperdiet viverrainterdum in leo. Nullam ullamcorper id enim fermentu                integerpraesent bibendum. In ullamcorper purus scelerisque malesuada etegestas. Ac dictumst mauris sed facilisis.",
    }
]

export { data };